/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Familias formativas
 * @export
 * @interface FormativeFamilies
 */
export interface FormativeFamilies {
    /**
     * 
     * @type {number}
     * @memberof FormativeFamilies
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FormativeFamilies
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FormativeFamilies
     */
    programs?: string;
}

export function FormativeFamiliesFromJSON(json: any): FormativeFamilies {
    return FormativeFamiliesFromJSONTyped(json, false);
}

export function FormativeFamiliesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormativeFamilies {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'programs': !exists(json, 'programs') ? undefined : json['programs'],
    };
}

export function FormativeFamiliesToJSON(value?: FormativeFamilies | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'programs': value.programs,
    };
}


